// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_GREY_2
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { Bar } from './Bar';
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartFashionFootprint: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    pounds: 0
  }));

  const chartData = inView ? data : initialData;
  const colors = { pounds: SPOT_BRAND };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.id];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    barComponent: Bar,
    colors: getColors,
    data: chartData,
    enableGridY: true,
    indexBy: 'change',
    keys: ['pounds'],
    layout: 'horizontal',
    margin: { top: 0, right: 80, bottom: 0, left: 0 },
    padding: 0.6,
    theme: {
      ...DEFAULT_CHART_PROPS.theme,
      grid: {
        line: {
          stroke: SPOT_GREY_2,
          strokeWidth: 1
        }
      }
    }
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartFashionFootprint };
